import type { GroupBookingDetail, GroupItem } from "../types";

export interface IGroupsState {
  groups: GroupItem[];
  isLoading: boolean;
  isBooking: boolean;
  bookingDetail: GroupBookingDetail | null;
  isFetchingBookingDetail: boolean;
  isUpdatingPassengers: boolean;
  payingInvoiceId: string | null;
}

const state: IGroupsState = {
  groups: [],
  isLoading: false,
  isBooking: false,
  bookingDetail: null,
  isFetchingBookingDetail: false,
  isUpdatingPassengers: false,
  payingInvoiceId: null,
};

export default state;
